module.exports = __webpack_public_path__ + "5695c7a68f473f618ac04458e8881ac5.svg";